import walidacjaRejestracji from '@components/form/validation/field/numerRejestracyjny'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Numer rejestracyjny',
    name: 'numer-rejestracyjny',

}, walidacjaRejestracji)